import React from "react";
import { Box, Flex, Image, Link } from "@chakra-ui/react";

const navItems = [
  { link: { href: "mailto:contact@withloma.com", label: "Contact" } },
];

const Header = () => {
  return (
    <Box as="header" position="relative" zIndex={20}>
      <Box maxW="1200px" mx="auto" py={{ base: 4, sm: 8 }}>
        <Flex justify="space-between">
          <Link href="/" ml={{ base: 2, sm: 12 }} display="flex" alignItems="center">
            <Image
              alt="Loma Logo"
              width={92}
              height={22}
              loading="eager"
              fetchPriority="high"
              decoding="async"
              src="/Logo-02.png"
            />
          </Link>
          <Flex align="center" gap={4} mr={{ base: 2, sm: 12 }}>
            <Flex as="nav" gap={3}>
              {navItems.map(({ link }, i) => {
                return (
                  <Link
                    key={i}
                    href={link.href}
                    bg="#0F4245"
                    color="white"
                    style={{ borderRadius: ".2rem" }}
                    px={6}
                    py={2}
                    h="36px"
                    fontSize="sm"
                    display="block"
                    _hover={{ textDecoration: "none" }}
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    {link.label}
                  </Link>
                );
              })}
            </Flex>
            {/* hamburger, no fries */}
            {/* <Menu className='mr-2 sm:mr-12 h-12 w-12 text-white' />   */}
          </Flex>
        </Flex>
      </Box>
    </Box>
  )
  // return (
  //   <MotionBox
  //     as="header"
  //     w="100%"
  //     bg="transparent"
  //     position="relative"
  //     zIndex={1000}
  //     initial={{ opacity: 0, y: -20 }}
  //     animate={{ opacity: 1, y: 0 }}
  //     transition={{ duration: 0.6, ease: "easeOut" }}
  //   >
  //     <Container maxW="1200px" px={{ base: 4, md: 8 }} py={{ base: 4, md: 6 }}>
  //       <MotionFlex
  //         justify="space-between"
  //         align="center"
  //         wrap="nowrap"
  //         gap={{ base: 2, md: 4 }}
  //         initial={{ opacity: 0 }}
  //         animate={{ opacity: 1 }}
  //         transition={{ delay: 0.2, duration: 0.6 }}
  //       >
  //         {/* Logo */}
  //         <MotionBox
  //           whileHover={{ scale: 1.05 }}
  //           transition={{ duration: 0.2 }}
  //           flexShrink={0}
  //           display="flex"
  //           alignItems="center"
  //           gap={2}
  //           bg={LOMA_LANDING_DARK_TEAL}
  //           px={{ base: 3, md: 6 }}
  //           py={{ base: 2, md: 3 }}
  //           borderRadius="8px"
  //           height={{ base: "32px", md: "40px" }}
  //         >
  //           <Image
  //             src="/Logo-02.png"
  //             alt="Loma Logo"
  //             height="100%"
  //           />
  //         </MotionBox>

  //         {/* Beta Tagline */}
  //         <MotionBox
  //           initial={{ opacity: 0, scale: 0.95 }}
  //           animate={{ opacity: 1, scale: 1 }}
  //           transition={{ delay: 0.4, duration: 0.6 }}
  //           display={{ base: "none", sm: "block" }}
  //           flexShrink={0}
  //         >
  //           <Text
  //             color={'white'}
  //             fontWeight="600"
  //             letterSpacing="0.1em"
  //             fontSize={{ base: "xs", md: "sm" }}
  //             textTransform="uppercase"
  //           >
  //             Now In Public Beta
  //           </Text>
  //         </MotionBox>

  //         {/* Contact Button */}
  //         <MotionBox
  //           whileHover={{ scale: 1.05 }}
  //           whileTap={{ scale: 0.95 }}
  //           initial={{ opacity: 0, x: 20 }}
  //           animate={{ opacity: 1, x: 0 }}
  //           transition={{ delay: 0.6, duration: 0.6 }}
  //           flexShrink={0}
  //         >
  //           <Button
  //             as={Link}
  //             href="mailto:contact@withloma.com"
  //             bg={LOMA_LANDING_DARK_TEAL}
  //             color="white"
  //             px={{ base: 3, md: 6 }}
  //             py={{ base: 2, md: 3 }}
  //             fontFamily="'Poppins', sans-serif"
  //             fontWeight="600"
  //             borderRadius="8px"
  //             border="0px"
  //             fontSize={{ base: "sm", md: "md" }}
  //             height={{ base: "32px", md: "40px" }}
  //             _hover={{
  //               bg: LOMA_LANDING_DARK_TEAL,
  //               textDecoration: "none",
  //               transform: "translateY(-2px)",
  //               boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  //             }}
  //             _active={{
  //               transform: "translateY(0px)",
  //             }}
  //             transition="all 0.3s ease"
  //           >
  //             Contact Us
  //           </Button>
  //         </MotionBox>
  //       </MotionFlex>
  //     </Container>
  //   </MotionBox>
  // );
};

export default Header;
